// extracted by mini-css-extract-plugin
module.exports = {"head":"Catalog_head__2OW2Q","list":"Catalog_list__TgccY","destination":"Catalog_destination__3GZlM","button":"Catalog_button__RemlE"};